import React, { useEffect, useRef, useState } from "react";
import { DropDownObjectWithString } from "src/dataModels/docListModel"
import AddGoals from "./docAddGoals"
import moment from "moment";
import { customAxios } from "src/services/useExPressApi";
import { API_ENDPOINTS } from "src/services/api-endpoints";


export interface AddGoalsUsingPatientListProps {
    selectedPatientList: DropDownObjectWithString[]
    isEdit: boolean
    onDataStateChange(id: any, data: any): void
    preselctedGoalEdit: any
    isViewDoc: boolean
    tpIdNumber: number
    isDraft: boolean
    draftCommonControlls: []
}


export const AddGoalsUsingPatientList = (props: AddGoalsUsingPatientListProps) => {
    const [docGoalTemplates, setDocGoalTemplates] = useState([]);
    const [isTemplateFetched, setIstemplateFetched] = useState(false)

    useEffect(() => {
        if (!isTemplateFetched) {
            fetchGoalTemplateList()
            setIstemplateFetched(true)
        }
    }, [isTemplateFetched])


    const fetchGoalTemplateList = async () => {
        const templateResponse: any = await customAxios.get(API_ENDPOINTS.GET_DOC_GOAL_TEMPLATES);
        setDocGoalTemplates(templateResponse.resultData)
    }


    return <div>
        {(!props.isViewDoc) ?
            props.selectedPatientList.map((selectedClient) => {

                let draftGoalsArray = []

                let tpId = props.tpIdNumber

                if (props.isDraft) {
                    const currentControll: any = props.draftCommonControlls.find((item: any) => item.clientId === selectedClient.id)
                    if (currentControll) {
                        tpId = currentControll.treatmentPlanTemplateId
                        draftGoalsArray = currentControll.documentGoals ? currentControll.documentGoals : []
                    }
                }
                return <div>

                    {<AddGoals
                        goalTemplateList={docGoalTemplates}
                        isEdit={props.isEdit}
                        isDraft={props.isDraft}
                        preselectedData={props.preselctedGoalEdit}
                        preselectedDataDraft={draftGoalsArray}
                        selectedClient={selectedClient}
                        tpId={tpId ? tpId : 0}
                        onDataStateISChanged={props.onDataStateChange} />
                    }

                </div>
            })

            : (props.preselctedGoalEdit) ?
                props.preselctedGoalEdit.map((selectedGoals, index) => {
                    return <div className="col-12 p-0">
                        <div key={index} className="p-2 border mt-2">
                            <div className="row m-0 align-items-center">
                                <div className="form-group mb-1 mt-1 pl-0 col-lg-12 col-lg-12">
                                    <span className="fw-600">Goal Name</span>
                                    <div className='content'>{selectedGoals.goalName}</div>
                                </div>


                                <div className="form-group mb-1 mt-1 pl-0 col-md-12">
                                    <span className="fw-600">Target Date</span>
                                    <div className='content'>{selectedGoals.targetDate && moment(selectedGoals.targetDate).format('M/D/YYYY')}</div>
                                </div>

                                <div className="form-group mb-1 mt-1 pl-0 col-md-12">
                                    <span className="fw-600">Description</span>
                                    <div className='content'>{selectedGoals.goalDescription}</div>
                                </div>

                                <div className="form-group mb-1 mt-1  col-md-12 pl-0">
                                    {selectedGoals && selectedGoals.objectives &&
                                        selectedGoals?.objectives.map((ObjectiveSelected) => {
                                            return <div className='row m-0 borderTop pb-3'>
                                                <div className='col-md-12 pl-0'>
                                                    <span className="fw-600">Objective</span>
                                                    <div className='content'> {ObjectiveSelected.objective}</div>
                                                </div>
                                                <div className='col-md-12 p-0'>
                                                    {
                                                        ObjectiveSelected.interventions &&
                                                        ObjectiveSelected.interventions.map((selectedIntervention, index) => {
                                                            return <div >

                                                                <div>
                                                                    <div className="form-group mb-1 mt-1 ">
                                                                        <span className="fw-600">Intervention</span>
                                                                        <div className='content'>{selectedIntervention.intervention}</div>
                                                                        <span className="fw-600">Service Type</span>
                                                                        <div className='content'>{selectedIntervention.serviceType}</div>
                                                                        <span className="fw-600">Frequency:</span>
                                                                        <div className='content'>{selectedIntervention.numFreq} {selectedIntervention.freq}</div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        })
                                    }


                                </div>

                            </div></div>


                    </div>
                }) : <div />

        }
    </div>

}


